﻿import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const th: Dictionary = {
  "nav": {
    "home": "หน้าแรก",
    "map": "แผนที่",
    "tracker": "ตัวติดตาม",
    "resources": "ทรัพยากร",
    "fish": "ปลา",
    "insects": "แมลง",
    "birds": "นก",
    "foraging": "เก็บของป่า",
    "crops": "พืชผล",
    "flowers": "ดอกไม้",
    "animals": "สัตว์",
    "recipes": "สูตรอาหาร",
    "locations": "ตำแหน่ง",
    "npcs": "NPC",
    "shops": "ร้านค้า",
    "guides": "คู่มือ",
    "news": "ข่าวสาร",
    "achievements": "ความสำเร็จ",
    "weather": "สภาพอากาศ",
    "events": "อีเวนต์",
    "pets": "สัตว์เลี้ยง",
    "dailyChecklist": "เช็กลิสต์รายวัน",
    "codes": "โค้ดแลกรางวัล",
    "winterTracker": "ติดตามฤดูหนาว",
    "support": "สนับสนุน",
    "about": "เกี่ยวกับ",
    "furniture": "เฟอร์นิเจอร์",
    "wardrobe": "เสื้อผ้า",
    "buildings": "สิ่งก่อสร้าง",
    "resourcesCollection": "ของสะสม",
    "resourcesDecorate": "ตกแต่ง",
    "resourcesExplore": "สำรวจ",
    "resourcesLearn": "เรียนรู้",
    "menu": "เมนู",
  },
  "search": {
    "placeholder": "ค้นหาทุกอย่าง…",
    "categoryItems": "ของสะสม",
    "categoryNpcs": "NPC",
    "categoryLocations": "ตำแหน่ง",
    "categoryGuides": "คู่มือ",
    "categoryNews": "ข่าวสาร",
    "categoryAchievements": "ความสำเร็จ",
    "noResults": "ไม่พบผลลัพธ์",
    "noResultsHint": "ลองใช้คำค้นหาอื่น",
    "navigate": "นำทาง",
    "select": "เลือก",
    "close": "ปิด",
  },
  "language": {
    "title": "ภาษา",
    "subtitle": "เลือกภาษาที่คุณต้องการ",
  },
  "footer": {
    "description": "คู่มือภาคสนาม Heartopia ที่ผู้เล่นสร้างขึ้นสำหรับเส้นทาง สูตร สถานที่ และงานรวบรวม",
    "quickLinks": "ลิงค์ด่วน",
    "collection": "ของสะสม",
    "copyright": "Heartopia Hub",
    "disclaimer": "ไม่มีส่วนเกี่ยวข้องกับผู้พัฒนา Heartopia",
  },
  "home": {
    "badge": "คู่มือ Heartopia ฉบับแฟนเมด",
    "titleStop": "เลิก",
    "titleWandering": "หลงทาง",
    "titleStart": "เริ่มวางแผน",
    "description": "Heartopia.guide รวมแผนที่เกาะ สูตรอาหาร สิ่งมีชีวิต NPC และความคืบหน้าของคอลเล็กชันไว้ในที่เดียว ใช้ง่ายและรวดเร็ว",
    "openAtlas": "เปิดแผนที่",
    "tracker": "ตัวติดตาม",
    "statCatalogued": "รายการในแคตตาล็อก",
    "statLayers": "เลเยอร์แผนที่",
    "statFree": "ฟรีเสมอ",
    "islandAtlas": "แผนที่เกาะ",
    "mapLayerNpcs": "NPC",
    "mapLayerShops": "ร้านค้า",
    "mapLayerAnimals": "สัตว์",
    "mapHeading": "เกาะ Heartopia",
    "mapNearby": "ใกล้เคียง",
    "openMap": "เปิดแผนที่",
    "meetLocals": "พบปะชาวบ้าน",
    "hintNpcs": "ดูตำแหน่ง NPC ที่พูดคุยได้ทั้งหมดในครั้งเดียว",
    "hintShops": "ทุกร้านค้ามีสต๊อกพร้อมให้เลือกชม",
    "hintAnimals": "ค้นหาสัตว์ป่าตามจุดที่พบเป็นประจำ",
    "explore": "สำรวจ",
    "recipesPill": "สูตรอาหาร",
    "recipesTitle": "ปรุงอาหารอย่างชาญฉลาด",
    "recipesDescription": "เรียกดูอาหาร ห่วงโซ่ส่วนผสม และความคืบหน้าในการเก็บรวบรวมโดยไม่ต้องเปิดสิบแท็บ",
    "viewRecipes": "ดูสูตรอาหาร",
    "ingr": "ส่วนผสม",
    "profit": "กำไร",
    "animalsPill": "สัตว์ป่า",
    "animalsTitle": "พบกับพวกเขาทั้งหมด",
    "animalsDescription": "อาหารโปรด สภาพอากาศ และคำใบ้ตำแหน่งของสัตว์ป่าทุกชนิด",
    "viewAnimals": "ดูสัตว์ต่างๆ",
    "guidesPill": "คู่มือ",
    "guidesTitle": "เลือกโฟกัส",
    "guidesDescription": "เลือกหนึ่งในสามหัวข้อ — เปิดคู่มือที่ตรงกับเป้าหมายของคุณได้ทันที",
    "allGuides": "คู่มือทั้งหมด",
    "exploreGuide": "ดูคู่มือ",
  },
  "guides": {
    "pillLabel": "ไกด์ภาคสนาม",
    "titleLearn": "เรียนรู้",
    "titleAccent": "ทุกระบบ",
    "searchPlaceholder": "ค้นหาคู่มือ…",
    "categoryAll": "ทั้งหมด",
    "categoryBeginner": "ระดับเริ่มต้น",
    "categoryCrafting": "งานหัตถกรรม",
    "categoryCooking": "ทำอาหาร",
    "categoryFishing": "ตกปลา",
    "categoryExploration": "การสำรวจ",
    "difficultyEasy": "ง่าย",
    "difficultyMedium": "ปานกลาง",
    "difficultyHard": "ยาก",
    "allGuides": "คู่มือทั้งหมด",
    "by": "โดย",
    "minRead": "นาทีอ่าน",
    "noResults": "ไม่พบคำแนะนำ ลองค้นหาหรือหมวดหมู่อื่น",
    "relatedGuides": "คู่มือที่เกี่ยวข้อง",
    "readGuide": "อ่านคู่มือ",
  },
  "news": {
    "pillLabel": "ข่าว Heartopia",
    "titleWhats": "มีอะไร",
    "titleAccent": "ใหม่",
    "searchPlaceholder": "ค้นหาข่าว…",
    "categoryAll": "ทั้งหมด",
    "categoryEvent": "อีเวนต์",
    "categoryUpdate": "อัปเดต",
    "categoryGuide": "แนะนำ",
    "categoryNews": "ข่าวสาร",
    "featured": "จุดเด่น",
    "allNews": "ข่าวทั้งหมด",
    "read": "อ่าน",
  },
  "map": {
    "controls": "การควบคุมแผนที่",
    "zoomIn": "ซูมเข้า",
    "zoomOut": "ซูมออก",
    "resetMap": "รีเซ็ตแผนที่",
    "fullscreen": "เต็มจอ",
    "viewDetails": "ดูรายละเอียด",
    "viewLocation": "ดูสถานที่",
    "openFullMap": "เปิดแผนที่แบบเต็ม",
    "seeMore": "ดูเพิ่มเติม",
    "close": "ปิด",
    "back": "กลับ",
    "guide": "คู่มือ",
    "searchPlaceholder": "ค้นหา NPC ร้านค้า นก ปลา...",
    "clearSearch": "ล้างการค้นหา",
    "area": "พื้นที่",
    "mapArea": "พื้นที่แผนที่",
    "event": "อีเวนต์",
    "resource": "ทรัพยากร",
    "location": "สถานที่",
    "npc": "NPC",
    "shop": "ร้านค้า",
    "busStop": "ป้ายรถเมล์",
    "wildAnimal": "สัตว์ป่า",
    "focus": "จุดสนใจ",
    "hide": "ซ่อน",
    "show": "แสดง",
    "showAllShops": "แสดงร้านค้าทั้งหมด",
    "showAllAnimals": "แสดงสัตว์ทั้งหมด",
    "showBugAreas": "แสดงพื้นที่แมลง",
    "showBirdAreas": "แสดงพื้นที่นก",
    "showResources": "แสดงทรัพยากรบนแผนที่",
    "showEvents": "แสดงอีเวนต์บนแผนที่",
    "showFishAreas": "แสดงพื้นที่ปลา",
    "viewAnimalAreas": "ดูพื้นที่สัตว์",
    "clickToView": "คลิกเพื่อดู",
    "spots": "จุด",
    "meteorShower": "ฝนดาวตก",
    "foundIn": "พบใน",
    "more": "เพิ่มเติม",
    "sectionsNpcs": "NPC",
    "sectionsShops": "ร้านค้า",
    "sectionsBusStops": "ป้ายรถเมล์",
    "sectionsAnimals": "สัตว์",
    "sectionsBugs": "แมลง",
    "sectionsBirds": "นก",
    "sectionsResources": "ทรัพยากร",
    "sectionsWeather": "สภาพอากาศ",
    "sectionsEvents": "อีเวนต์",
    "sectionsFish": "ปลา",
    "shopClothes": "เสื้อผ้า",
    "shopFurniture": "เฟอร์นิเจอร์",
    "shopPets": "สัตว์เลี้ยง",
    "shopBookstore": "ร้านหนังสือ",
    "helpTitle": "วิธีใช้แผนที่",
    "helpSearchLead": "ค้นหา",
    "helpSearchText": "NPC ร้านค้า สิ่งมีชีวิต หรือพื้นที่ตามชื่อด้วยช่องด้านบน",
    "helpLayersLead": "เลเยอร์",
    "helpLayersText": "ในแถบด้านข้างสลับสิ่งที่ปรากฏบนแผนที่: NPC ร้านค้า สัตว์ ทรัพยากร และอื่นๆ แตะหมวดหมู่เพื่อขยายรายการทั้งหมด",
    "helpClickLead": "คลิกหมุด พื้นที่ หรือรายการ",
    "helpClickText": "เพื่อดูข้อมูลพื้นฐานในการ์ดที่ด้านล่างของแผนที่ พร้อมปุ่มเพื่อดูหน้ารายละเอียดทั้งหมดเมื่อมีข้อมูลอยู่",
  },
  "locations": {
    "title": "สถานที่",
    "subtitleSuffix": "สถานที่ทั่วเกาะ Heartopia",
    "openMap": "เปิดแผนที่",
    "searchPlaceholder": "ค้นหาสถานที่…",
    "allLocations": "สถานที่ทั้งหมด",
    "npcsHere": "NPC ที่นี่",
    "shopsHere": "ร้านค้าที่นี่",
    "listings": "รายการ",
    "foundHereTitle": "พบได้ที่นี่",
    "foundHereHint": "สิ่งมีชีวิตและทรัพยากรที่คุณเก็บได้ในจุดนี้",
    "onTheMapTitle": "บนแผนที่",
    "sameRegionTitle": "เพิ่มเติมในภูมิภาค{region}",
    "statNpcs": "NPC",
    "statShops": "ร้านค้า",
    "statCollectibles": "ของสะสม",
    "levelShort": "Lv. {level}",
    "eventOnly": "อีเวนต์",
    "seeListings": "ดูรายการขาย",
    "seeAll": "ดูทั้งหมด",
    "timeOfDay": "ช่วงเวลา",
    "nothingHereTitle": "ยังไม่มีข้อมูลบันทึกไว้ที่นี่",
    "nothingHereBody": "เรายังไม่มีข้อมูลสิ่งมีชีวิต ร้านค้า หรือ NPC ในจุดนี้ ถ้าคุณเจออะไรที่นี่ แผนที่เป็นวิธีที่เร็วที่สุดในการบอกเราว่าอยู่ตรงไหน",
    "regionTown": "เมือง",
    "regionNature": "ธรรมชาติ",
    "regionAdventure": "การผจญภัย",
    "regionCoast": "ชายฝั่ง",
    "regionSea": "ทะเล",
    "regionRegion": "ภูมิภาค",
    "regionFishingVillage": "หมู่บ้านชาวประมง",
    "regionForest": "ป่า",
    "regionMountain": "ภูเขา",
    "regionBeach": "ชายหาด",
    "regionOther": "อื่น",
  },
  "catalog": {
    "howItWorks": "มันทำงานอย่างไร",
    "fishPill": "สารานุกรมประมง",
    "fishTitlePrefix": "จับ",
    "fishTitleAccent": "ปลาทุกตัว",
    "fishSearchPlaceholder": "ค้นหาปลา ถิ่นอาศัย ขนาดเงา…",
    "fishSliderLabel": "ระดับการตกปลา",
    "fishIntroTitle": "ตกปลา 101",
    "fishIntroP1": "เหวี่ยงเบ็ดไปใกล้แหล่งที่อยู่อาศัยของปลาเพื่อจับ — ขนาดเงาบ่งบอกว่าอะไรกำลังกัด",
    "fishIntroP2": "ระดับการตกปลาที่สูงขึ้นจะปลดล็อกการจับที่หายากขึ้น และคุณภาพของดาวจะเพิ่มราคาขายของคุณเป็นทวีคูณ",
    "fishUnknownHabitat": "น่านน้ำที่ไม่รู้จัก",
    "fishHabitat": "ถิ่นอาศัย",
    "fishNoResultsTitle": "ไม่พบปลา",
    "fishNoResultsBody": "ลองปรับตัวกรองของคุณ",
    "fishPastEventTitle": "ปลาจากอีเวนต์ที่ผ่านมา",
    "fishHeaderTitle": "ปลา",
    "fishColFish": "ปลา",
    "fishColShadow": "เงา",
    "insectsPill": "สารานุกรมจับแมลง",
    "insectsTitlePrefix": "จับ",
    "insectsTitleAccent": "แมลงทุกชนิด",
    "insectsSearchPlaceholder": "ค้นหาแมลง ถิ่นอาศัย…",
    "insectsSliderLabel": "ระดับการจับ",
    "insectsIntroTitle": "การจับแมลง 101",
    "insectsIntroP1": "ใช้ตาข่ายดักแมลงใกล้แหล่งที่อยู่อาศัยของแมลงเพื่อจับมัน",
    "insectsIntroP2": "ระดับการจับที่สูงขึ้นจะปลดล็อกแมลงที่หายากขึ้น และคุณภาพดาวจะเพิ่มราคาขายเป็นทวีคูณ",
    "insectsUnknownHabitat": "ไม่ทราบ",
    "insectsPastEventTitle": "แมลงจากอีเวนต์ที่ผ่านมา",
    "insectsHeaderTitle": "แมลง",
    "insectsColInsect": "แมลง",
    "birdsPill": "สารานุกรมการดูนก",
    "birdsTitlePrefix": "ค้นหา",
    "birdsTitleAccent": "นกทุกตัว",
    "birdsSearchPlaceholder": "ค้นหานก ถิ่นอาศัย…",
    "birdsSliderLabel": "ระดับการดูนก",
    "birdsIntroTitle": "ดูนก 101",
    "birdsIntroP1": "รอใกล้ถิ่นที่อยู่ของนกพร้อมกับพุ่มไม้พรางตัวของคุณเพื่อถ่ายรูป",
    "birdsIntroP2": "ระดับการดูนกที่สูงขึ้นจะปลดล็อคสายพันธุ์ที่หายาก",
    "birdsUnknownHabitat": "ไม่ทราบ",
    "birdsPastEventTitle": "นกจากอีเวนต์ที่ผ่านมา",
    "birdsHeaderTitle": "นก",
    "birdsColBird": "นก",
    "cropsPill": "สารานุกรมการเกษตร",
    "cropsTitlePrefix": "ปลูก",
    "cropsTitleAccent": "ทุกพืชผล",
    "cropsSearchPlaceholder": "ค้นหาพืชผล…",
    "cropsIntroTitle": "การทำฟาร์ม 101",
    "cropsIntroP1": "ปลูกเมล็ดพันธุ์ในแปลงฟาร์มของคุณและรดน้ำทุกวันจนกว่าจะเก็บเกี่ยว",
    "cropsIntroP2": "พืชบางชนิดจะเติบโตได้ในบางฤดูกาลเท่านั้น — ตรวจสอบตราประจำฤดูกาลก่อนปลูก",
    "cropsAllSeasons": "ทุกฤดูกาล",
    "cropsGrowthTime": "ระยะเวลาเติบโต",
    "cropsGrowthTimeUnknown": "ไม่ทราบ",
    "cropsGrowthTimeMinutesSuffix": "นาที",
    "cropsSortGrowthTime": "ระยะเวลาเติบโต",
    "cropsHeaderTitle": "พืชผล",
    "cropsColCrop": "พืชผล",
    "cropsColSeason": "ฤดูกาล",
    "flowersPill": "สารานุกรมการทำสวน",
    "flowersTitlePrefix": "ปลูก",
    "flowersTitleAccent": "ทุกดอกไม้",
    "flowersSearchPlaceholder": "ค้นหาดอกไม้…",
    "flowersIntroTitle": "การทำสวน 101",
    "flowersIntroP1": "ปลูกเมล็ดดอกไม้และรดน้ำให้ออกดอก",
    "flowersHeaderTitle": "ดอกไม้",
    "flowersColFlower": "ดอกไม้",
    "furniturePill": "แคตตาล็อกเฟอร์นิเจอร์",
    "furnitureTitlePrefix": "รวมทุก",
    "furnitureTitleAccent": "เฟอร์นิเจอร์ในเกม",
    "furnitureSearchPlaceholder": "ค้นหาเฟอร์นิเจอร์…",
    "furnitureMetaDescription":
      "เฟอร์นิเจอร์ทั้งหมดใน Heartopia — ไฟตกแต่ง เก้าอี้ โต๊ะ เตียง พรม และของตกแต่ง กรองตามประเภท ห้อง และสีได้ พร้อมทุกแบบและราคาทั้งทองและดาวขอพร",
    "browseAll": "ทั้งหมด",
    "browseVariants": "{count} แบบ",
    "browseShowMore": "แสดงเพิ่ม {count} รายการ",
    "browseFacetRooms": "ห้อง",
    "browseFacetColors": "สี",
    "browseFacetSlots": "ประเภท",
    "browseFacetTypes": "ประเภท",
    "browseFacetSets": "คอลเลกชัน",
    "browseCollectionsMore": "ดูทั้งหมด",
    "browseCollectionsLess": "แสดงน้อยลง",
    "browseCollectionPieces": "{count} ชิ้น",
    "browseFavourites": "รายการโปรด",
    "browseNoArt": "เกมไม่มีรูปสำหรับชิ้นนี้",
    "browseFacetStyles": "สไตล์การสร้าง",
    "buildingsPill": "แคตตาล็อกโหมดสร้าง",
    "buildingsTitlePrefix": "รวมทุก",
    "buildingsTitleAccent": "ชิ้นส่วนสร้างบ้าน",
    "buildingsSearchPlaceholder": "ค้นหาประตู หลังคา หน้าต่าง…",
    "buildingsMetaDescription":
      "ชิ้นส่วนโหมดสร้างทั้งหมดใน Heartopia — ประตู หน้าต่าง หลังคา รั้ว ประติมากรรมผนัง และพื้นผิวผนังกับพื้น — จัดกลุ่มตามสไตล์การสร้าง พร้อมราคาและทุกแบบ",
    "wardrobePill": "แคตตาล็อกเสื้อผ้า",
    "wardrobeTitlePrefix": "รวมทุก",
    "wardrobeTitleAccent": "ชุดและเครื่องประดับ",
    "wardrobeSearchPlaceholder": "ค้นหาเสื้อผ้า…",
    "wardrobeMetaDescription":
      "หมวก เสื้อ กางเกง รองเท้า กระเป๋า และเครื่องประดับทั้งหมดใน Heartopia กรองตามประเภทและสีได้ พร้อมราคาทั้งทองและดาวขอพร",
    "forageablesPill": "สารานุกรมของเก็บได้",
    "forageablesTitlePrefix": "หา",
    "forageablesTitleAccent": "ของเก็บได้ทั้งหมด",
    "forageablesSearchPlaceholder": "ค้นหาสิ่งที่หาได้…",
    "forageablesIntroTitle": "การหาอาหาร 101",
    "forageablesIntroP1": "เดินไปรอบๆ เกาะและเก็บพืชป่าและเห็ดตามที่คุณพบ",
    "forageablesEnergy": "พลังงาน",
    "forageablesSortEnergy": "พลังงาน",
    "forageablesHeaderTitle": "ของเก็บได้",
    "forageablesColItem": "รายการ",
    "recipesPill": "รวมสูตรอาหาร",
    "recipesTitlePrefix": "ทำอาหาร",
    "recipesTitleAccent": "ทุกจาน",
    "recipesSearchPlaceholder": "ค้นหาสูตรอาหาร…",
    "recipesIntroTitle": "ทำอาหาร 101",
    "recipesIntroP1": "รวบรวมส่วนผสมแล้วใช้เตา เตาอบ หรือเตาย่างในการปรุงอาหาร",
    "recipesIntroP2": "ระดับการทำอาหารที่สูงขึ้นจะปลดล็อกสูตรอาหารที่แปลกใหม่พร้อมอัตรากำไรที่มากขึ้น",
    "recipesSortCookingLevel": "ระดับการทำอาหาร",
    "recipesSortProfit": "กำไร",
    "recipesEstProfit": "กำไรโดยประมาณ",
    "recipesViewRecipe": "ดูสูตร",
    "recipesHeaderTitle": "สูตรอาหาร",
    "recipesColDish": "จาน",
    "recipesBeginnerFriendly": "เป็นมิตรสำหรับผู้เริ่มต้น",
    "recipesBestStartersTitle": "สูตรอาหารที่ดีที่สุดที่จะเริ่มต้นด้วย",
    "recipesBestStartersSubtitle": "ระดับการทำอาหารต่ำ ผลกำไรที่มั่นคง — ตัวเลือกที่ดีสำหรับการปลดล็อคงานอดิเรกทำอาหารครั้งแรกของคุณ",
    "npcsPill": "ไดเรกทอรีชาวเมือง",
    "npcsTitlePrefix": "พบปะ",
    "npcsTitleAccent": "ทุก NPC",
    "npcsSearchPlaceholder": "ค้นหา NPC…",
    "npcsFilterAll": "ทั้งหมด",
    "npcsFilterMentors": "พี่เลี้ยง",
    "npcsFilterShopkeepers": "เจ้าของร้าน",
    "npcsFilterSpecial": "พิเศษ",
    "npcsNoResultsTitle": "ไม่พบ NPC",
    "npcsNoResultsBody": "ลองปรับการค้นหาของคุณ",
    "npcsResetFilters": "รีเซ็ตตัวกรอง",
    "locationsPill": "แผนที่เกาะ",
    "locationsTitlePrefix": "สำรวจ",
    "locationsTitleAccent": "ทุกสถานที่",
    "locationsFilterAll": "ทั้งหมด",
    "locationsNoResultsTitle": "ไม่พบสถานที่",
    "locationsNoResultsBody": "ลองปรับการค้นหาของคุณ",
    "locationsResetFilters": "รีเซ็ตตัวกรอง",
    "shopsPill": "ไดเรกทอรีร้านค้า",
    "shopsTitlePrefix": "ทั้งหมด",
    "shopsTitleAccent": "ร้านค้าในเมือง",
    "shopsRunBy": "ดำเนินการโดย:",
    "shopsAt": "ที่",
    "shopsItemsForSale": "รายการขาย",
    "shopsSearchPlaceholder": "ค้นหาร้านค้า NPC สถานที่…",
    "shopsNoResultsTitle": "ไม่พบร้านค้า",
    "shopsNoResultsBody": "ลองปรับการค้นหาของคุณ",
    "shopsResetFilters": "รีเซ็ตตัวกรอง",
    "animalsBadge": "คู่มือสัตว์ป่า",
    "animalsTitlePrefix": "พบปะ",
    "animalsTitleAccent": "สัตว์ทุกตัว",
    "animalsPastEvent": "อีเวนต์ที่ผ่านมา",
    "animalsPastEventTitle": "สัตว์จากอีเวนต์ที่ผ่านมา",
    "trackerBadge": "ความคืบหน้าการรวบรวม",
    "trackerTitle": "ตัวติดตาม Heartopia",
    "trackerDescription":
      "ทำเครื่องหมายปลา แมลง นก พืชผล ดอกไม้ ของเก็บได้ สูตรอาหาร และสัตว์ป่าที่สะสมแล้ว ความคืบหน้าจะบันทึกไว้ในเบราว์เซอร์นี้",
    "trackerMetaDescription": "ติดตามความคืบหน้าคอลเล็กชัน Heartopia ทั้งปลา แมลง นก พืชผล ดอกไม้ ของเก็บได้ สัตว์ และสูตรอาหาร",
    "trackerCategoryTitle": "ตัวติดตาม {category}",
    "trackerCategoryMetaDescription":
      "ติดตามความคืบหน้าในการเก็บรวบรวม Heartopia {category} — ดูสิ่งที่คุณจับได้ ปลูก หรือปรุงสุก และยังมีสิ่งใดที่ยังขาดหายไป",
    "trackerTotal": "ทั้งหมด",
    "trackerExport": "ส่งออก",
    "trackerImport": "นำเข้า",
    "trackerReset": "รีเซ็ต",
    "trackerImportComplete": "นำเข้าเสร็จสมบูรณ์",
    "trackerImportFailed": "การนำเข้าล้มเหลว",
    "trackerSearchPlaceholder": "ค้นหาคอลเล็กชัน...",
    "trackerAllCategories": "ทุกหมวดหมู่",
    "trackerAllItems": "ทุกรายการ",
    "trackerCollected": "รวบรวม",
    "trackerMissing": "หายไป",
    "trackerNoResults": "ไม่มีรายการติดตามที่ตรงกับตัวกรองปัจจุบัน",
  },
  "genericDetail": {
    "subtitle": "รายการในสารานุกรม",
    "sellPrice": "ราคาขาย",
    "energy": "พลังงาน",
    "whereToBuy": "หาซื้อได้ที่ไหน",
    "tags": "แท็ก",
    "crafted": "สร้างขึ้น",
    "aliases": "หรือเรียกอีกอย่างว่า",
    "howToObtain": "วิธีการได้รับ",
    "growsInto": "เติบโตเป็น",
    "universalIngredientTitle": "ส่วนผสมในการทำอาหารที่ยืดหยุ่น",
    "universalIngredientBody": "สามารถใช้แทนส่วนผสมใดๆ ในการทำอาหารตามสูตรได้",
  },
  "animalDetail": {
    "backLabel": "สัตว์ทั้งหมด",
    "subtitle": "รายการคู่มือสัตว์ป่า",
    "statLocation": "ที่ตั้ง",
    "statFavoriteWeather": "สภาพอากาศที่ชื่นชอบ",
    "foundInTitle": "พบใน",
    "favoriteFoodsTitle": "อาหารที่ชอบ",
    "noPinTitle": "ยังไม่ได้ปักหมุดจุดที่แน่นอนของสัตว์ตัวนี้",
    "noPinDescription": "มันเดินเตร่อยู่ในพื้นที่ของมัน ดังนั้นเราจึงไม่ได้กำหนดเครื่องหมายตายตัวให้กับมัน",
    "weatherSunny": "แดดจัด",
    "weatherWet": "ฝนตก",
    "weatherRainbow": "รุ้ง",
    "weatherSnowy": "หิมะตก",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "cropDetail": {
    "backLabel": "พืชผลทั้งหมด",
    "subtitle": "รายการสารานุกรมการเกษตร",
    "statGrowthTime": "ระยะเวลาเติบโต",
    "statSellPrice": "ราคาขาย",
    "aboutTitle": "เกี่ยวกับ",
    "seedCostTitle": "ต้นทุนเมล็ดพันธุ์",
    "usedInRecipesTitle": "ใช้ในตำรับอาหาร",
    "sellPriceByStarTitle": "ราคาขายตามสตาร์",
    "faqTitle": "คำถามที่พบบ่อย",
    "shopsTitle": "ซื้อเมล็ดพันธุ์ได้ที่ไหน",
  },
  "creatureDetail": {
    "allBirds": "นกทั้งหมด",
    "allInsects": "แมลงทั้งหมด",
    "allFish": "ปลาทั้งหมด",
    "birdSubtitle": "รายการสารานุกรมการดูนก",
    "insectSubtitle": "รายการสารานุกรมการจับแมลง",
    "fishSubtitle": "รายการสารานุกรมประมง",
    "statShadowSize": "ขนาดเงา",
    "markAsObtained": "ทำเครื่องหมายว่าได้รับแล้ว",
    "shopsTitle": "หาซื้อได้ที่ไหน",
    "locationsTitle": "ถิ่นอาศัย",
    "sellPriceByStarTitle": "ราคาขายตามสตาร์",
    "starChanceHint": "โอกาสที่จะได้ระดับสตาร์นี้",
    "statWeightRange": "น้ำหนัก",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "forageableDetail": {
    "backLabel": "ของเก็บได้ทั้งหมด",
    "subtitle": "รายการในสารานุกรมของเก็บได้",
    "statEnergy": "พลังงาน",
    "shopsTitle": "หาซื้อได้ที่ไหน",
    "locationsTitle": "พบใน",
    "aboutBody": "เดินไปรอบ ๆ เกาะแล้วหยิบสิ่งนี้ขึ้นมาเมื่อคุณพบมันในป่า",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "flowerDetail": {
    "backLabel": "ดอกไม้ทั้งหมด",
    "shopsTitle": "ซื้อเมล็ดพันธุ์ได้ที่ไหน",
    "encyclopediaEntry": "รายการสารานุกรมการจัดสวน",
    "colorsTitle": "สี",
    "otherColorsTitle": "สีอื่นๆ",
    "crossbreedingTitle": "การผสมข้ามพันธุ์",
    "crossbreedingFact1": "ใช้ได้เฉพาะดอกไม้สายพันธุ์เดียวกัน — กุหลาบผสมข้ามพันธุ์ได้กับกุหลาบเท่านั้น ไม่ใช่ทิวลิป",
    "crossbreedingFact2":
      "ดอกไม้มีระดับดาว (1–5) ดอกพ่อแม่ที่มีดาวเท่ากันอาจให้ระดับเดิมหรือสูงขึ้นหนึ่งระดับ คู่ดาวที่ติดกัน (เช่น 2★ กับ 3★) ก็ใช้ได้ แต่คู่ที่ห่างกว่านั้นผสมไม่ได้ และดอกไม้ 5★ จะไม่ให้เมล็ดเพิ่ม",
    "crossbreedingFact3":
      "สีไม่ใช่วัตถุดิบผสม — สีของดอกพ่อแม่จะไม่รวมเป็นสีที่สาม แต่ละสีมักผูกกับระดับดาวของสายพันธุ์นั้น ผลลัพธ์จึงขึ้นกับระดับดาวมากกว่าสีเริ่มต้น",
    "crossbreedingFact4":
      "การรดน้ำเพิ่มโอกาสได้สูงสุดประมาณ 5 คน (คุณและผู้ช่วยอีกไม่เกิน 4 คน) และระดับทำสวนจะเพิ่มโบนัสอีกส่วนหนึ่ง ผลลัพธ์จะออกหลังเซิร์ฟเวอร์รีเซ็ตเวลา 6:00 น.",
    "crossbreedingDisclaimer": "ยังไม่มีแหล่งข้อมูลที่เชื่อถือได้ระบุอัตราสำเร็จที่แน่นอน — มีโอกาสเลื่อนระดับ แต่ไม่รับประกัน",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "npcDetail": {
    "backLabel": "NPC ทั้งหมด",
    "aboutTitle": "เกี่ยวกับ",
    "funFactsTitle": "ข้อเท็จจริงที่สนุกสนาน",
    "foundInTitle": "พบใน",
    "itemsForSale": "รายการขาย",
    "profileTitle": "ประวัติโดยย่อ",
    "birthdayLabel": "วันเกิด",
    "zodiacLabel": "ราศี",
    "mbtiLabel": "MBTI",
    "likesTitle": "ชอบ",
    "roleLabel": "บทบาท",
    "teachesLabel": "สอน",
    "forSaleLabel": "ขาย",
    "townsfolkFallback": "ชาวเมือง",
    "townsfolkSubtitle": "ชาวเมือง Heartopia",
    "itemsSuffix": "รายการ",
    "noMapPinTitle": "ตำแหน่งที่แน่นอนของ NPC นี้ยังไม่ได้ปักหมุดไว้",
    "noMapPinDescription": "พวกมันเดินเตร่หรือเคลื่อนที่ไปมา ดังนั้นเราจึงไม่ได้กำหนดเครื่องหมายตายตัวสำหรับพวกมัน",
    "currencyGold": "Gold",
    "currencyStars": "Stars",
    "currencyWishingStars": "Wishing Stars",
    "currencyMoonlightCrystals": "Moonlight Crystals",
    "currencyHeartDiamonds": "Heart Diamonds",
    "currencyExhibitionPasses": "Exhibition Passes",
    "currencyContributionMedals": "Contribution Medals",
    "seeAllShopItems": "ดูไอเทมทั้ง {count} ชิ้นใน {shop} →",
  },
  "recipeDetail": {
    "faqIngredientsQuestion": "ทำ {name} อย่างไร?",
    "faqIngredientsAnswer": "{name} ต้องใช้: {ingredients}",
    "faqLevelQuestion": "ต้องใช้เลเวลทำอาหารเท่าไหร่สำหรับ {name}?",
    "faqLevelAnswer": "ต้องมีเลเวลทำอาหาร {level} เพื่อปลดล็อก {name}",
    "faqSellQuestion": "{name} ขายได้เท่าไหร่?",
    "faqSellAnswer": "{name} ขายได้ {price} ทอง",
    "faqStarQuestion": "{name} ระดับ 5 ดาวมีค่าเท่าไหร่?",
    "faqStarAnswer": "{name} ขายได้ {min} ทองที่ 1★ และ {max} ทองที่ 5★ — มากกว่า {times}× เมื่อทำได้สมบูรณ์แบบ",
    "faqEnergyQuestion": "{name} ฟื้นฟูพลังงานเท่าไหร่?",
    "faqEnergyAnswer": "{name} ฟื้นฟูพลังงาน {min} ที่ 1★ และ {max} ที่ 5★",
    "backLabel": "สูตรอาหารทั้งหมด",
    "subtitle": "รายการ Masterlist ของสูตร",
    "statCookingLevel": "ระดับการทำอาหาร",
    "statTool": "เครื่องมือ",
    "statSellPrice": "ราคาขาย",
    "shopsTitle": "หาซื้อได้ที่ไหน",
    "aboutTitle": "เกี่ยวกับ",
    "faqTitle": "คำถามที่พบบ่อย",
    "ingredientsTitle": "วัตถุดิบ",
    "noIngredients": "ไม่มีการบันทึกส่วนผสมสำหรับสูตรนี้",
    "missingIngredientsTitle": "เราไม่ทราบส่วนผสมของสูตรนี้",
    "missingIngredientsCta": "แตะเพื่อเพิ่ม",
    "suggestIngredientsModalTitle": "แนะนำส่วนผสม",
    "ingredientSearchPlaceholder": "ค้นหารายการ…",
    "ingredientQtyLabel": "จำนวน",
    "addIngredientRow": "เพิ่มส่วนผสม",
    "removeIngredientRow": "ลบ",
    "submitIngredients": "ส่งข้อเสนอแนะ",
    "submittingIngredients": "กำลังส่ง…",
    "ingredientsSuccessMessage": "ขอบคุณ! เราจะตรวจสอบข้อเสนอแนะของคุณเร็วๆ นี้",
    "ingredientsErrorMessage": "ไม่สามารถส่งได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
    "itemNotFoundCta": "หาไม่เจอ? แนะนำไอเทมใหม่",
    "newItemPendingBadge": "รอดำเนินการ",
    "suggestNewItemModalTitle": "แนะนำไอเทมใหม่",
    "newItemNameLabel": "ชื่อไอเทม",
    "newItemNamePlaceholder": "เช่น Mandarin",
    "newItemKindLabel": "หมวดหมู่",
    "newItemNotesLabel": "หมายเหตุ (ไม่บังคับ)",
    "newItemNotesPlaceholder": "อะไรก็ได้ที่ช่วยเราเติมเข้าไป — หาได้ที่ไหน ลักษณะเป็น…",
    "submitNewItem": "ส่งข้อเสนอแนะ",
    "submittingNewItem": "กำลังส่ง…",
    "newItemSuccessMessage": "ขอบคุณ! เราจะตรวจสอบและเพิ่มเร็วๆ นี้",
    "newItemErrorMessage": "ไม่สามารถส่งได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
    "anyTag": "ใดๆ",
    "possibleSubstitutesTitle": "สิ่งทดแทนที่เป็นไปได้",
    "possibleSubstitutesNote": "ไอเทมทุกชิ้นในแคตตาล็อกประเภทนี้ — รายการที่ Heartopia ยอมรับจริงอาจมีน้อยกว่านี้",
    "estIngredientCost": "ต้นทุนวัตถุดิบโดยประมาณ",
    "estProfit": "กำไรโดยประมาณ",
    "sellPriceByStar": "ราคาขายตามสตาร์",
    "starScalingNote": "ตัวคูณการทำอาหารมาตรฐาน (1x/1.5x/2x/4x/8x) — มีอาหารเพียงไม่กี่ชนิดที่ใช้ตารางต่างออกไป",
    "energyByStar": "พลังงานโดยสตาร์",
    "toolStove": "เตา",
    "toolOven": "เตาอบ",
    "toolPopcornServingCart": "รถเข็นป๊อปคอร์น",
    "toolPenguinStove": "เตาเพนกวิน",
    "toolBrickServingCart": "รถเข็นอิฐ",
    "toolNone": "ไม่มี",
  },
  "common": {
    "loading": "กำลังโหลด",
    "overviewTitle": "ภาพรวม",
    "viewDetails": "ดูรายละเอียด",
    "cards": "การ์ด",
    "list": "รายการ",
    "sort": "เรียงลำดับ",
    "name": "ชื่อ",
    "level": "ระดับ",
    "price": "ราคาขาย",
    "clearFilters": "ล้างตัวกรอง",
    "day": "วัน",
    "days": "วัน",
    "shadowSizeSmall": "เล็ก",
    "shadowSizeMedium": "ปานกลาง",
    "shadowSizeLarge": "ใหญ่",
    "shadowSizeGolden": "สีทอง",
    "usedInRecipesTitle": "ใช้ในตำรับอาหาร",
    "aboutTitle": "เกี่ยวกับ",
  },
  "itemFaq": {
    "whereToFindQuestion": "ฉันจะหา {name} ได้ที่ไหนในเกม Heartopia?",
    "whereToFindByLocationsAnswer": "สามารถพบ {name} ได้ที่ {locations}",
    "whereToFindByHabitatAnswer": "{name} เกี่ยวข้องกับที่อยู่อาศัยแบบ {habitat}",
    "levelRequiredQuestion": "ต้องใช้เลเวลเท่าไหร่ในการจับ {name}?",
    "levelRequiredAnswer": "คุณต้องมีเลเวลอย่างน้อย {level} เพื่อจับ {name}",
    "sellPriceQuestion": "{name} ขายได้เท่าไหร่?",
    "sellPriceAnswer": "{name} ขายได้ {price} โกลด์",
    "sellPriceWithShadowAnswer": "{name} ขายได้ {price} โกลด์ และขนาดเงาตอนตกปลาคือ {shadowSize}",
    "weatherQuestion": "ต้องใช้สภาพอากาศแบบไหนสำหรับ {name}?",
    "weatherAnswer": "{name} ปรากฏในช่วง: {weather}",
    "usedForQuestion": "{name} ใช้ทำอะไร?",
    "usedForAnswer": "{name} ฟื้นฟูพลังงาน {energy} เมื่อกิน",
  },
  "recipeFaq": {
    "ingredientsQuestion": "ต้องใช้วัตถุดิบอะไรบ้างสำหรับ {name}?",
    "ingredientsAnswer": "{name} ต้องใช้: {ingredients}",
    "cookingLevelQuestion": "ต้องใช้ระดับการทำอาหารเท่าไรสำหรับ {name}?",
    "cookingLevelAnswer": "คุณต้องมีระดับการทำอาหาร {level} เพื่อปลดล็อก {name}",
    "sellPriceQuestion": "{name} ขายได้เท่าไร?",
    "sellPriceAnswer": "{name} ขายได้ {price} ทอง",
  },
  "itemDescription": {
    "foundAtClause": "พบได้ที่ {locations}",
    "foundInHabitatClause": "เกี่ยวข้องกับที่อยู่อาศัยแบบ {habitat}",
    "requiresLevelClause": "ต้องการเลเวลอย่างน้อย {level} เพื่อให้ได้มา",
    "sellsForClause": "ขายได้ {price} โกลด์",
    "restoresEnergyClause": "ฟื้นฟูพลังงาน {energy} เมื่อกิน",
    "joinWord": "และ",
  },
  "starTooltip": {
    "profitTitle": "ตัวคูณดาว",
    "profitSubtitle": "กำไรต่อการจัดอันดับดาว",
    "profitFooterLabel": "กำไร 1★",
    "sellPriceTitle": "ตัวคูณดาว",
    "sellPriceSubtitle": "ราคาขายต่อระดับดาว",
    "sellPriceFooterLabel": "1 ★ ราคาขาย",
  },
  "mastery": {
    "trackFishing": "การเรียนรู้การตกปลา",
    "trackBugCatching": "การเรียนรู้การจับแมลง",
    "trackBirdwatching": "การเรียนรู้การดูนก",
    "trackFarming": "การเรียนรู้การเพาะปลูก",
    "trackCooking": "การเรียนรู้การทำอาหาร",
    "unitCatches": "ครั้งที่จับได้",
    "unitCaptures": "ครั้งที่บันทึกได้",
    "unitHarvests": "ครั้งที่เก็บเกี่ยว",
    "unitPreparations": "ครั้งที่ปรุง",
    "rankNovice": "มือใหม่",
    "rankExpert": "ผู้เชี่ยวชาญ",
    "rankMaster": "ปรมาจารย์",
    "trophyUnlocked": "ถ้วยรางวัล",
    "footerHint": "แตะที่ระดับเพื่อบันทึกความคืบหน้าของคุณ ไปให้ถึงระดับปรมาจารย์เพื่อปลดล็อกถ้วยรางวัล",
    "unknownBody": "เรายังไม่ทราบเกณฑ์การเรียนรู้ของไอเทมนี้",
    "unknownCta": "คุณรู้ตัวเลขไหม? บอกเราได้เลย",
    "suggestFieldLabel": "เกณฑ์การเรียนรู้ระดับมือใหม่",
    "suggestHint": "แค่ตัวเลขของระดับมือใหม่ — ในทุกไอเทมที่เรายืนยันแล้ว ผู้เชี่ยวชาญคือ 3 เท่า และปรมาจารย์คือ 6 เท่าของตัวเลขนั้น",
  },
  "statSuggestion": {
    "unknownLabel": "เรายังไม่รู้เลย",
    "suggestValueCta": "แนะนำค่า",
    "explainer":
      "เรายังไม่มีการยืนยันเรื่องนี้ หากคุณรู้จักมันจากการเล่น แบ่งปันด้านล่าง — ทุกข้อเสนอแนะจะได้รับการตรวจสอบก่อนที่จะเผยแพร่บนเว็บไซต์ ดังนั้นอย่ากดดันให้แน่ใจ 100%",
    "genericHint": "แค่ตัวเลข ไม่ต้องฟอร์แมตเพิ่มเติม",
    "energyHint": "ปริมาณพลังงานที่ได้รับคืนเมื่อใช้ไอเทมชิ้นนี้",
    "sellPriceHint": "ราคาขายพื้นฐานระดับ 1★ ในหน่วย Gold — เราจะคำนวณระดับดาวอื่นให้",
    "habitatHint": "สถานที่ที่พบ — ระบุชื่อสถานที่หรือพื้นที่",
    "growthTimeHint": "เป็นนาที (เช่น 90 สำหรับ 1 ชั่วโมง 30 นาที 1440 สำหรับ 1 วัน)",
    "valueLabel": "ค่า",
    "customOption": "อื่นๆ (พิมพ์เอง)",
    "habitatTranslationFieldLabel": "ชื่อที่อยู่อาศัยในภาษานี้",
    "habitatTranslationHint": "วิธีการเรียกสถานที่/พื้นที่นี้ในภาษานี้",
    "submitButton": "ส่งข้อเสนอแนะ",
    "submitting": "กำลังส่ง…",
    "successMessage": "ขอบคุณ! เราจะตรวจสอบข้อเสนอแนะของคุณเร็วๆ นี้",
    "errorMessage": "ไม่สามารถส่งได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
  },
  "imageSuggestion": {
    "triggerLabel": "แนะนำรูปภาพ",
    "triggerLabelReplace": "แนะนำรูปภาพอื่น",
    "fieldLabel": "แนะนำรูปภาพ",
    "explainer": "เรายังไม่มีภาพที่ยืนยันสำหรับเรื่องนี้ อัปโหลดสิ่งที่คุณมี — ทุกข้อเสนอแนะจะได้รับการตรวจสอบก่อนที่จะเพิ่มลงในไซต์",
    "explainerReplace": "คิดว่าภาพนี้ผิดหรืออาจจะดีกว่านี้? อัปโหลดภาพที่คุณมี — ทุกข้อเสนอแนะจะได้รับการตรวจสอบก่อนที่จะแทนที่รูปภาพปัจจุบัน",
    "pickFile": "เลือกรูปภาพ (JPEG, PNG หรือ WebP)",
    "hint": "สูงสุด 5MB โปรดตรวจสอบว่ารูปภาพตรงกับไอเทมนี้",
    "invalidType": "ยอมรับเฉพาะรูปภาพ JPEG, PNG หรือ WebP เท่านั้น",
    "tooLarge": "รูปภาพต้องมีขนาด 5MB หรือเล็กกว่า",
    "submitButton": "ส่งภาพ",
    "submitting": "กำลังอัพโหลด…",
    "successMessage": "ขอบคุณ! เราจะตรวจสอบภาพของคุณเร็วๆ นี้",
    "errorMessage": "ไม่สามารถอัปโหลดได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
  },
  "generalFeedback": {
    "triggerLabel": "พบข้อมูลผิด? แนะนำการแก้ไข",
    "fieldLabel": "ข้อมูลส่วนไหนไม่ถูกต้อง?",
    "hint": "คำอธิบายผิด รูปภาพผิด หรืออย่างอื่น — บอกเราว่าต้องแก้ไขอะไร",
  },
  "pageFeedback": {
    "triggerLabel": "รายงานปัญหาเกี่ยวกับหน้านี้",
    "fieldLabel": "เกิดอะไรขึ้น?",
    "hint": "พิมพ์ผิด ขั้นตอนใช้งานไม่ได้ ข้อมูลล้าสมัย — แจ้งให้เราทราบ",
    "explainer":
      "เรายังไม่มีการยืนยันเรื่องนี้ หากคุณพบเห็นสิ่งผิดปกติ โปรดแชร์ไว้ด้านล่าง — ทุกการส่งจะได้รับการตรวจสอบก่อนที่เราจะดำเนินการ ดังนั้นจึงไม่จำเป็นต้องมั่นใจ 100%",
    "submitButton": "ส่งคำติชม",
    "submitting": "กำลังส่ง…",
    "successMessage": "ขอบคุณ! เราจะมาดูกันเร็วๆ นี้",
    "errorMessage": "ไม่สามารถส่งได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
  },
  "mapAreaUnknown": {
    "title": "เรายังไม่รู้จักพื้นที่นี้",
    "description": "ช่วยเหลือชุมชนด้วยการให้ข้อมูลตำแหน่งสำหรับรายการนี้",
    "cta": "ช่วยเราเพิ่มสิ่งนี้",
    "fieldLabel": "ที่ตั้ง/พื้นที่",
    "hint": "อธิบายจุดที่พบ — ระบุชื่อสถานที่และจุดสังเกตใกล้เคียง",
    "notPinnedTitle": "จุดนี้ยังไม่ได้ปักหมุดบนแผนที่",
    "notPinnedDescription": "เรารู้พื้นที่ทั่วไป แต่ยังไม่ได้ระบุตำแหน่งที่ชัดเจน",
  },
  "itemGuides": {
    "title": "คำแนะนำที่เกี่ยวข้อง",
  },
  "itemFallback": {
    "badge": "อยู่ระหว่างการแปล",
    "message": "เรายังไม่ทราบชื่อรายการนี้ในภาษานี้",
    "usingEnglish": "การใช้ภาษาอังกฤษ:",
    "helpMessage": "เรายังไม่ทราบชื่อรายการนี้ ต้องการที่จะช่วยเรา?",
    "helpCta": "ช่วยแปลด้วย",
    "modalTitle": "แนะนำคำแปล",
    "fieldPlaceholder": "ชื่อรายการในภาษานี้",
    "submitButton": "ส่งข้อเสนอแนะ",
    "submitting": "กำลังส่ง…",
    "successMessage": "ขอบคุณ! เราจะตรวจสอบข้อเสนอแนะของคุณเร็วๆ นี้",
    "errorMessage": "ไม่สามารถส่งได้ในขณะนี้ — โปรดลองอีกครั้งในภายหลัง",
  },
  "notFoundPage": {
    "title": "404",
    "subtitle": "อ๊ะ ไม่พบหน้านี้",
    "description": "คุณเดินเข้าไปในพื้นที่ที่ยังไม่มีอยู่ใน Heartopia ให้คุณกลับมาสู่เส้นทางอีกครั้ง",
    "primaryCta": "กลับบ้าน",
    "secondaryCta": "ดูแผนที่โลก",
  },
  "achievements": {
    "pill": "ความสำเร็จ",
    "titlePrefix": "ปลดล็อคทุก",
    "titleAccent": "ความสำเร็จ",
    "subtitle": "ติดตามความคืบหน้าของคุณและค้นพบวิธีปลดล็อกทุกความสำเร็จใน Heartopia",
    "searchPlaceholder": "ค้นหาความสำเร็จ…",
    "filterAll": "ทั้งหมด",
    "showHidden": "แสดงความสำเร็จลับ",
    "hideHidden": "ซ่อนความสำเร็จลับ",
    "statTotal": "ทั้งหมด",
    "statCompleted": "สมบูรณ์",
    "statHidden": "ที่ซ่อนอยู่",
    "noResultsTitle": "ไม่พบความสำเร็จ",
    "noResultsBody": "ลองค้นหาหรือกรองอื่น",
    "resetFilters": "รีเซ็ตตัวกรอง",
    "lockedTitle": "???",
    "lockedBody": "ความสำเร็จนี้ยังคงเป็นปริศนา",
    "titleGainedLabel": "ได้รับตำแหน่งแล้ว",
    "hintLabel": "คำใบ้",
    "notesLabel": "หมายเหตุ",
    "markDone": "ทำเครื่องหมายว่าเสร็จแล้ว",
    "markNotDone": "ทำเครื่องหมายว่ายังไม่เสร็จ",
    "backToList": "กลับไปที่ความสำเร็จ",
    "relatedTitle": "ความสำเร็จที่เกี่ยวข้อง",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "share": {
    "title": "แบ่งปัน",
    "shareVia": "แชร์ผ่าน…",
    "copyLink": "คัดลอกลิงก์",
    "linkCopied": "คัดลอก!",
  },
  "weather": {
    "pill": "สถานีตรวจอากาศ",
    "titlePrefix": "Heartopia",
    "titleAccent": "พยากรณ์",
    "subtitle": "ตรวจสอบเงื่อนไขเพื่อวางแผนเส้นทาง ค้นหากิจกรรม และเตรียมพร้อมสำหรับการเกิดที่หายาก",
    "directoryTitle": "คู่มือสภาพอากาศและกิจกรรม",
    "specialEvent": "กิจกรรมพิเศษ",
    "openGuide": "เปิดคำแนะนำ",
    "backToWeather": "กลับไปที่สภาพอากาศ",
    "overviewTitle": "ภาพรวม",
    "checklistTitle": "หากคุณมีเวลาเพียง 10 นาที",
    "activitiesTitle": "กิจกรรมสำคัญ",
    "bestForTitle": "ดีที่สุดสำหรับ",
    "creaturesTitle": "พบได้ในสภาพอากาศนี้",
    "creaturesMore": "มากกว่า",
    "creaturesShowLess": "แสดงให้น้อยลง",
    "noCreaturesData": "เรายังไม่มีสิ่งมีชีวิตที่ติดแท็กสำหรับสภาพอากาศนี้",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "events": {
    "pill": "กำหนดการ Heartopia",
    "titlePrefix": "อีเวนต์ที่กำลัง",
    "titleAccent": "อีเวนต์",
    "subtitle": "ตั้งแต่เทศกาลสำคัญตามฤดูกาลไปจนถึงมินิเกมรายวัน ค้นหาทุกสิ่งที่เกิดขึ้นใน Heartopia",
    "minigamesTitle": "มินิเกมที่เกิดซ้ำ",
    "seasonalTitle": "กิจกรรมตามฤดูกาลและการทำงานร่วมกัน",
    "activeLabel": "กำลังดำเนินอยู่",
    "endedLabel": "สิ้นสุดแล้ว",
    "viewEvent": "ดูอีเวนต์",
    "backToEvents": "กลับไปที่กิจกรรม",
    "requirementsTitle": "ความต้องการ",
    "locationTitle": "ที่ตั้ง",
    "costTitle": "ค่าใช้จ่ายในการเข้า",
    "freeLabel": "ฟรี",
    "dgLevelLabel": "ระดับ Developer's Guild",
    "questLabel": "ภารกิจ",
    "hobbyLabel": "งานอดิเรก",
    "quickFactsTitle": "ข้อมูลด่วน",
    "unlockLabel": "ปลดล็อค",
    "npcAreaLabel": "NPC / พื้นที่",
    "durationLabel": "ระยะเวลา",
    "typeLabel": "พิมพ์",
    "howToStartTitle": "วิธีการเริ่มต้น",
    "howItWorksTitle": "มันทำงานอย่างไร",
    "goalsRewardsTitle": "เป้าหมายและรางวัล",
    "tipsTitle": "เคล็ดลับ/กลยุทธ์",
    "datesTitle": "วันที่จัดกิจกรรม",
    "overviewTitle": "ภาพรวม",
    "highlightsTitle": "ไฮไลท์",
    "standoutRewardTitle": "รางวัลอันโดดเด่น",
    "faqTitle": "คำถามที่พบบ่อย",
  },
  "pets": {
    "hubBadge": "คู่มือสัตว์เลี้ยง",
    "hubTitlePrefix": "Heartopia",
    "hubTitleAccent": "สัตว์เลี้ยง",
    "hubSubtitle": "ทุกสิ่งที่คุณต้องการเพื่อปลดล็อค รับเลี้ยง และดูแลสัตว์เลี้ยง",
    "hubUnlockTitle": "ปลดล็อคการดูแลสัตว์เลี้ยง",
    "hubUnlockDesc": "โดยปกติจะอยู่ที่ Developer/Member Level 12 ผ่าน Resident Requests",
    "hubOrderTitle": "แมวก่อน",
    "hubOrderDesc": "คุณต้องรับเลี้ยงแมวก่อนที่สุนัขจะปลดล็อค",
    "hubRotationTitle": "การหมุนรายวัน",
    "hubRotationDesc": "แมว 3 ตัว + สุนัข 3 ตัวหมุนเวียนกันทุกวันที่ศูนย์รับเลี้ยงบุตรบุญธรรม",
    "cardDogsTitle": "สุนัข",
    "cardDogsSubtitle": "สายพันธุ์ • การดูแล • กลุ่ม",
    "cardDogsDesc": "37 สายพันธุ์พร้อมกลุ่มขนาดและบันทึกการดูแล",
    "cardCatsTitle": "แมว",
    "cardCatsSubtitle": "สายพันธุ์ • ลักษณะ • เสื้อโค้ต",
    "cardCatsDesc": "18 สายพันธุ์พร้อมพันธุ์ขนและสี",
    "cardTraitsTitle": "ลักษณะ",
    "cardTraitsSubtitle": "ลักษณะทั้งหมด + การค้นหา",
    "cardTraitsDesc": "รายการลักษณะและผลกระทบที่สามารถค้นหาได้",
    "cardGuideTitle": "แนะนำ",
    "cardGuideSubtitle": "ปลดล็อค • รับเลี้ยง • เอาใจใส่",
    "cardGuideDesc": "ปลดล็อกโฟลว์บวกกับวงจรการรับเลี้ยงบุตรบุญธรรม/การดูแลรายวัน",
    "dogsBadge": "คู่มือสุนัข",
    "dogsTitlePrefix": "Heartopia",
    "dogsTitleAccent": "สุนัข",
    "dogsSubtitle": "ปลดล็อค รับเลี้ยง และดูแลสุนัขด้วยแคตตาล็อกสายพันธุ์ที่สะอาดตา",
    "catsBadge": "คู่มือแมว",
    "catsTitlePrefix": "Heartopia",
    "catsTitleAccent": "แมว",
    "catsSubtitle": "สายพันธุ์ ลักษณะ และการดูแล — สะอาดและแยกออกจากกัน",
    "quickInfoRotationTitle": "การหมุนรายวัน",
    "quickInfoRotationDesc": "แมว 3 ตัว + หมา 3 ตัว หมุนเวียนกันทุกวัน",
    "quickInfoUnlockTitle": "ปลดล็อค",
    "quickInfoUnlockDesc": "Dog Careing เปิดให้บริการหลัง Cat Careing",
    "quickInfoOrderTitle": "แมวก่อน",
    "quickInfoOrderDesc": "แมวปลดล็อคก่อนหมา",
    "quickInfoTraitsTitle": "ลักษณะสุ่ม",
    "quickInfoTraitsDescDogs": "นิสัยเป็นแบบสุ่มไม่ผูกมัดกับสายพันธุ์",
    "quickInfoTraitsDescCats": "ลักษณะจะสุ่มและเน้นพฤติกรรม",
    "searchPlaceholder": "ค้นหาสายพันธุ์…",
    "filterAll": "ทั้งหมด",
    "filterSmall": "เล็ก",
    "filterMedium": "ปานกลาง",
    "filterLarge": "ใหญ่",
    "noResults": "ไม่พบสายพันธุ์",
    "traitsBadge": "ลักษณะสัตว์เลี้ยง",
    "traitsTitlePrefix": "ทั้งหมด",
    "traitsTitleAccent": "ลักษณะ",
    "traitsSubtitle": "ลักษณะทุกอย่างที่สัตว์เลี้ยงสามารถมีได้ และความหมายของการดูแลในแต่ละวัน",
    "traitsSearchPlaceholder": "ลักษณะการค้นหา…",
    "effectLabel": "ผล",
    "guideBadge": "การดูแลสัตว์เลี้ยง",
    "guideTitlePrefix": "การรับเลี้ยงบุตรบุญธรรม",
    "guideTitleAccent": "แนะนำ",
    "guideSubtitle": "ปลดล็อคการดูแลสัตว์เลี้ยง รับเลี้ยงแมวตัวแรกของคุณ จากนั้นจึงขยายไปสู่สุนัข",
    "guideStepsTitle": "วิธีการปลดล็อค",
    "guideAdoptionTitle": "การรับเลี้ยงบุตรบุญธรรมทำงานอย่างไร",
    "guideCareTitle": "ห่วงการดูแลรายวัน",
    "backToPets": "กลับไปที่สัตว์เลี้ยง",
    "viewBreed": "ดูสายพันธุ์",
    "groupLabel": "ขนาด",
    "dogLabel": "สุนัข",
    "catLabel": "แมว",
    "variantsLabel": "พันธุ์โค้ตที่รู้จัก",
    "suggestTitle": "ขาดสายพันธุ์หรือรายละเอียด?",
    "suggestDogsBody": "ช่วยเราขยายแคตตาล็อกสุนัขด้วยสายพันธุ์ พันธุ์ หรือการแก้ไข",
    "suggestCatsBody": "ช่วยเราขยายแคตตาล็อกแมวด้วยสายพันธุ์ ขน หรือการแก้ไข",
    "suggestButton": "แนะนำรายการ",
    "suggestFieldLabel": "ข้อมูลสัตว์เลี้ยง",
    "suggestHint": "แบ่งปันสายพันธุ์ ตัวแปร แหล่งที่มา หรือการแก้ไขที่คุณทราบ",
    "viewAllTraits": "ดูลักษณะทั้งหมด",
  },
  "dailyChecklist": {
    "badge": "ติดตามรายวัน",
    "titlePrefix": "รายวัน",
    "titleAccent": "Heartopia",
    "subtitle": "ติดตามงานประจำวัน ทรัพยากร และการหมุนเวียนร้านค้าของคุณ ทุกอย่างเริ่มต้นใหม่พร้อมกับวันใหม่",
    "progressTitle": "ความคืบหน้ารายวัน",
    "progressComplete": "สมบูรณ์",
    "allDone": "ยินดีด้วย! คุณทำภารกิจทั้งหมดของวันนี้เสร็จแล้ว!",
    "quickTasksTitle": "งานด่วน",
    "quickTasksDesc": "การกระทำที่จำเป็นในแต่ละวันซึ่งจะรีเซ็ตในแต่ละวัน",
    "shopsTitle": "การหมุนเวียนร้านค้า",
    "shopsDesc": "ตรวจสอบสต็อกหมุนเวียนจากผู้ขายเหล่านี้",
    "resetInfo": "รีเซ็ตโดยอัตโนมัติตามวันที่ท้องถิ่นของคุณ",
    "customTitle": "งานที่กำหนดเอง",
    "addCustom": "เพิ่ม",
    "customPlaceholder": "ชื่องาน…",
    "customEmpty": "ยังไม่มีงานที่กำหนดเอง",
    "remove": "ลบ",
  },
  "codes": {
    "badge": "ศูนย์ไถ่ถอน",
    "title": "ของขวัญ",
    "titleAccent": "รหัส",
    "subtitle": "แลกรหัสเหล่านี้ในเกมเพื่อรับรางวัลพิเศษ ทอง และไอเทมสุดพิเศษ!",
    "statActive": "กำลังใช้งาน",
    "statExpired": "หมดอายุแล้ว",
    "statTotal": "ทั้งหมด",
    "howToTitle": "วิธีการแลก",
    "howToStep1": "เปิดเมนูเกม",
    "howToStep2": "แตะที่ 'การตั้งค่า' > 'แลกรหัส'",
    "howToStep3": "กรอกรหัสให้ตรงตามที่แสดง",
    "howToStep4": "ยืนยันและรับรางวัลของคุณ!",
    "rewardsLabel": "รางวัล",
    "noRewardsLabel": "ไม่มีรายการรางวัล",
    "starQualityHint": "รหัสนี้ให้ไอเทมตามคุณภาพดาวที่กำหนด",
    "unconfirmedRewardHint": "เรายังไม่มีรายการนี้ในแค็ตตาล็อกของเรา ดังนั้นนี่คือรหัสในเกมแทนที่จะเป็นชื่อที่ได้รับการยืนยัน",
    "expiredText": "รหัสนี้หมดอายุแล้วและไม่สามารถแลกได้อีกต่อไป",
    "copyCode": "คัดลอกรหัส",
    "copied": "คัดลอก!",
    "statusActive": "ใช้งานได้",
    "statusExpired": "หมดอายุแล้ว",
    "redeemedLabel": "แลกแล้ว",
    "markRedeemed": "ทำเครื่องหมายว่าแลกแล้ว",
    "unmarkRedeemed": "ยกเลิกการทำเครื่องหมายว่าแลกแล้ว",
    "goldLabel": "Gold",
    "starLabel": "Wishing Star",
    "heartLabel": "Moonlight Crystal",
    "maintenanceNote": "รหัสจะได้รับการตรวจสอบเป็นระยะๆ แต่อาจหมดอายุโดยไม่ต้องแจ้งให้ทราบ — หากใช้ไม่ได้ในเกม แสดงว่ารหัสนั้นล้าสมัย",
  },
  "winterTracker": {
    "badge": "วารสาร Fashionwave",
    "titlePrefix": "Winter Frost",
    "titleAccent": "ตัวติดตามรายการ",
    "subtitle": "ติดตามสินค้ารุ่นลิมิเต็ดเอดิชั่นทุกรายการจากฤดูกาล Winter Frost — กิจกรรมนี้สิ้นสุดลงแล้ว แต่คุณยังสามารถเรียกดูรายการที่มีอยู่ได้",
    "endedNote": "อีเวนต์นี้สิ้นสุดแล้ว — ไอเทมที่แสดงในหน้านี้ไม่สามารถรับในเกมได้อีก เก็บข้อมูลไว้เพื่อใช้อ้างอิง",
    "searchPlaceholder": "ค้นหารายการ…",
    "filterAll": "ทั้งหมด",
    "filterAccessory": "เครื่องประดับ",
    "filterBag": "กระเป๋า",
    "filterClothing": "เสื้อผ้า",
    "filterFurniture": "เฟอร์นิเจอร์",
    "filterEmote": "อิโมติคอน",
    "filterVehicle": "ยานพาหนะ",
    "filterTool": "เครื่องมือ",
    "filterPet": "รายการสัตว์เลี้ยง",
    "filterPuzzle": "ปริศนา",
    "collected": "รวบรวม",
    "missing": "ยังไม่ได้เก็บ",
    "noResults": "ไม่พบรายการ",
    "costLabel": "Fashionwave Tokens",
    "backToEvent": "กลับไปที่ Winter Frost",
  },
  "support": {
    "badge": "สนับสนุน heartopia.guide",
    "titlePrefix": "เก็บไว้",
    "titleAccent": "หัวใจ",
    "titleSuffix": "การตี",
    "subtitle":
      "heartopia.guide เป็นโครงการที่เกิดจากความหลงใหลที่สร้างขึ้นเพื่อชุมชน การสนับสนุนของคุณช่วยให้เซิร์ฟเวอร์ทำงานต่อไปและการอัปเดตที่กำลังจะมาถึง!",
    "donateCta": "สนับสนุนโครงการ",
    "donateDescription": "การสนับสนุนทุกครั้งจะครอบคลุมการโฮสต์ โดเมน และเวลาในการพัฒนา",
    "creatorLabel": "Lucas Diniz",
    "creatorRole": "ผู้สร้าง heartopia.guide",
    "creatorBadge": "นักพัฒนาและนักออกแบบ",
    "footerNote": "ขอบคุณที่เป็นส่วนหนึ่งของการเดินทางครั้งนี้!",
  },
  "about": {
    "badge": "แฟนโปรเจ็กต์ · ไม่เป็นทางการ",
    "title": "เกี่ยวกับ Heartopia Guide",
    "subtitle":
      "Heartopia Guide เป็นเว็บไซต์ที่ชุมชนสร้างขึ้นเพื่อช่วยให้ผู้เล่นค้นหาข้อมูลเกม ทั้งคู่มือ ตัวติดตาม เช็กลิสต์ ไอเทม และข้อมูลอีเวนต์ได้อย่างรวดเร็วและเป็นระเบียบ",
    "lastUpdatedLabel": "อัปเดตล่าสุด",
    "pillEventTrackers": "ตัวติดตามอีเวนต์",
    "pillGuides": "คู่มือ",
    "pillChecklists": "รายการตรวจสอบ",
    "pillAlwaysUpdated": "อัปเดตอยู่เสมอ",
    "whatYouFindTitle": "สิ่งที่คุณจะพบได้ที่นี่",
    "whatYouFind1": "ตัวติดตามอีเวนต์และรายการไอเทม (เมื่อมี)",
    "whatYouFind2": "คำแนะนำและหน้าอ้างอิงสำหรับกลไกของเกม",
    "whatYouFind3": "หน้ายูทิลิตี้เพื่อทำให้กิจวัตรรายวัน/รายสัปดาห์ง่ายขึ้น",
    "whatYouFind4": "ไซต์ที่มีการพัฒนาเมื่อเวลาผ่านไป — อัปเดตเมื่อมีข้อมูลใหม่",
    "transparencyTitle": "ประกาศความโปร่งใสและโครงการแฟน ๆ",
    "transparencyP1": "นี่เป็นโปรเจ็กต์แฟนอิสระและไม่เป็นทางการ เราไม่มีส่วนเกี่ยวข้อง สนับสนุน หรือรับรองโดยผู้สร้างหรือผู้จัดพิมพ์ Heartopia",
    "transparencyP2": "เครื่องหมายการค้า ชื่อ และทรัพย์สินทั้งหมดเป็นของเจ้าของที่เกี่ยวข้อง",
    "creatorTitle": "ใครอยู่เบื้องหลังเรื่องนี้.",
    "creatorIntro": "heartopia.guide ไม่ใช่โครงการนิรนาม — เว็บไซต์นี้สร้างและดูแลโดยบุคคลจริง",
    "creatorName": "Lucas Diniz",
    "creatorRole": "ผู้สร้างและผู้พัฒนา heartopia.guide",
    "creatorLinkLabel": "lucashdo.com",
    "sourcesTitle": "ข้อมูลมาจากไหน",
    "sourcesIntro": "ข้อมูลอาจมาจาก:",
    "sourcesItem1": "การสังเกตและการทดสอบในเกม",
    "sourcesItem2": "การมีส่วนร่วมของชุมชน",
    "sourcesItem3": "การอัปเดตเกมอย่างเป็นทางการ",
    "sourcesNote": "แม้เราจะตรวจสอบอย่างรอบคอบ แต่ข้อมูลบางส่วนอาจไม่ครบหรือล้าสมัย — โดยเฉพาะระหว่างอีเวนต์ที่กำลังดำเนินอยู่",
    "adsTitle": "โฆษณาและความยั่งยืน",
    "adsP1": "เพื่อให้ไซต์ทำงานต่อไปและครอบคลุมค่าใช้จ่าย (โดเมน โฮสติ้ง เครื่องมือ) เราอาจแสดงโฆษณา",
    "adsP2": "บริการโฆษณา เช่น Google อาจใช้คุกกี้หรือเทคโนโลยีที่คล้ายกันในการแสดงและวัดผลโฆษณา",
    "copyrightTitle": "ลิขสิทธิ์",
    "copyrightText":
      "หากคุณเป็นผู้ถือสิทธิ์และเชื่อว่าควรลบหรือปรับเปลี่ยนเนื้อหา โปรดติดต่อเราพร้อมแจ้ง URL และรายละเอียดที่เกี่ยวข้อง เราจะตรวจสอบและดำเนินการโดยเร็วที่สุด",
    "contactTitle": "ติดต่อ",
    "contactEmailLabel": "อีเมล",
    "footerNote": "ทำด้วยความรักโดยชุมชน Heartopia",
  },
  "legal": {
    "lastUpdatedLabel": "อัปเดตล่าสุด",
    "lastUpdatedValue": "2026-02-13",
    "contactHeading": "ติดต่อ",
    "contactLinkLabel": "หน้าเกี่ยวกับและติดต่อ",
    "privacyTitle": "นโยบายความเป็นส่วนตัว",
    "privacyIntro": "นโยบายความเป็นส่วนตัวนี้อธิบายว่า heartopia.guide รวบรวม ใช้ และปกป้องข้อมูลส่วนบุคคลอย่างไรเมื่อคุณเข้าถึงไซต์นี้",
    "privacyDataHeading": "ข้อมูลที่เราอาจรวบรวม",
    "privacyData":
      "เราอาจรวบรวม: ข้อมูลการเรียกดู/การใช้งาน (หน้าที่ดู การคลิก วันที่/เวลา ผู้อ้างอิง ประเภทอุปกรณ์/เบราว์เซอร์ ภาษา); ขึ้นอยู่กับวิธีที่คุณใช้ไซต์ ตัวระบุทางเทคนิค (เช่น IP ในบันทึก ข้อมูลความปลอดภัยและประสิทธิภาพ) คุกกี้และเทคโนโลยีที่คล้ายกัน (ดูนโยบายคุกกี้); และข้อมูลที่คุณให้ (เช่น หากคุณส่งอีเมลถึงเราหรือส่งข้อเสนอแนะ) เราไม่ขอข้อมูลที่ละเอียดอ่อน (เช่น สุขภาพ ศาสนา ข้อมูลชีวภาพ)",
    "privacyHowWeUseHeading": "วิธีที่เราใช้ข้อมูล",
    "privacyHowWeUse":
      "เราใช้ข้อมูลเพื่อจัดหาและบำรุงรักษาเว็บไซต์ ปรับปรุงเนื้อหาและประสิทธิภาพ ป้องกันการละเมิดและการฉ้อโกง ตอบกลับข้อความและการสนับสนุน วัดผู้ชมเมื่อเปิดใช้งาน และแสดงโฆษณา (ถ้ามี) และวัดประสิทธิภาพ",
    "privacySharingHeading": "การแบ่งปัน",
    "privacySharing":
      "เราอาจแบ่งปันข้อมูลกับผู้ให้บริการ (โฮสติ้ง การวิเคราะห์ CDN และ/หรือการโฆษณา) เพื่อดำเนินการเว็บไซต์ เมื่อจำเป็นตามกฎหมาย (คำสั่งศาล ภาระผูกพันด้านกฎระเบียบ) และเพื่อปกป้องเว็บไซต์และผู้ใช้ เราไม่ขายข้อมูลส่วนบุคคล",
    "privacyRetentionHeading": "การเก็บรักษา",
    "privacyRetention":
      "เราเก็บข้อมูลไว้นานเท่าที่จำเป็นเพื่อวัตถุประสงค์ที่อธิบายไว้ (หรือตามที่กฎหมายกำหนด) บันทึกทางเทคนิคอาจได้รับการเก็บรักษาไว้ในช่วงระยะเวลาที่จำกัดเพื่อความปลอดภัยและการวินิจฉัย",
    "privacyRightsHeading": "สิทธิของคุณ",
    "privacyRights":
      "คุณสามารถขอสิทธิ์ที่บังคับใช้ได้ภายใต้กฎหมายที่เกี่ยวข้อง (เช่น การเข้าถึง การแก้ไข การลบ การเคลื่อนย้ายได้ หากมี ข้อมูลเกี่ยวกับการแบ่งปัน การถอนความยินยอม) หากต้องการใช้สิทธิ์ โปรดติดต่อเราผ่านทางหน้าติดต่อพร้อมรายละเอียดคำขอของคุณ",
    "privacyAdvertisingHeading": "การโฆษณา",
    "privacyAdvertising":
      "เราใช้บริการโฆษณาของบุคคลที่สาม รวมถึง Google AdSense ผู้ให้บริการเหล่านี้อาจใช้คุกกี้และตัวระบุที่คล้ายกันในการให้บริการโฆษณา รวมถึงโฆษณาส่วนบุคคลตามการเข้าชมเว็บไซต์นี้และเว็บไซต์อื่น ๆ ของคุณครั้งก่อน \n\n คุณสามารถเลือกไม่รับโฆษณาส่วนบุคคลผ่าน Google Ads Settings และ/หรือ AboutAds (เลือกไม่รับการโฆษณาตามความสนใจ) โฆษณาที่ไม่ได้ปรับตามโปรไฟล์ของผู้ใช้อาจยังคงแสดงตามเนื้อหาและตำแหน่งทั่วไป",
    "privacyContactBefore": "หากมีคำถามหรือต้องการใช้สิทธิ์ โปรดไปที่",
    "termsTitle": "เงื่อนไขการใช้งาน",
    "termsIntro":
      'การเข้าถึงไซต์นี้ ("ไซต์") แสดงว่าคุณยอมรับข้อกำหนดเหล่านี้ เว็บไซต์นี้มีเนื้อหาที่ให้ข้อมูลและเครื่องมือของชุมชน คุณตกลงที่จะใช้มันอย่างถูกกฎหมายและด้วยความเคารพ',
    "termsUseHeading": "ทรัพย์สินทางปัญญาและเครื่องหมายการค้า",
    "termsUse":
      "เนื้อหาต้นฉบับของไซต์ (ข้อความ โครงสร้าง การออกแบบ) เป็นของ heartopia.guide เว้นแต่จะระบุไว้เป็นอย่างอื่น Heartopia ชื่อตัวละคร/รายการ เครื่องหมายการค้า และทรัพย์สินที่อ้างอิงเป็นของเจ้าของที่เกี่ยวข้อง เนื้อหาของบุคคลที่สามอาจปรากฏเพื่อใช้อ้างอิง หากคุณเป็นผู้ถือสิทธิ์และต้องการลบหรือปรับเปลี่ยน โปรดติดต่อเรา",
    "termsLiabilityHeading": "การปฏิเสธความรับผิดชอบและการจำกัดความรับผิด",
    "termsLiability":
      'เว็บไซต์นี้จัดทำขึ้น "ตามสภาพที่เป็นอยู่" เนื้อหาอาจไม่สมบูรณ์ ล้าสมัย หรือไม่สามารถใช้งานได้ชั่วคราว เราไม่รับประกันความพร้อมใช้งานอย่างต่อเนื่องหรือความถูกต้องครบถ้วน ภายในขอบเขตที่กฎหมายอนุญาต เราจะไม่รับผิดชอบต่อความเสียหายทางอ้อม การสูญหายของข้อมูล การสูญเสียผลกำไร หรือการสูญเสียอื่น ๆ ที่เกิดขึ้นจากการใช้ไซต์ เราอาจอัปเดตไซต์และข้อกำหนดเหล่านี้ได้ตลอดเวลา การใช้อย่างต่อเนื่องหลังจากการเปลี่ยนแปลงหมายถึงการยอมรับ',
    "termsContactBefore": "หากมีคำถามหรือคำขอ โปรดไปที่",
    "cookiesTitle": "นโยบายคุกกี้",
    "cookiesIntro": "นโยบายคุกกี้นี้อธิบายว่า heartopia.guide ใช้คุกกี้และเทคโนโลยีที่คล้ายกันเพื่อจดจำผู้เยี่ยมชมและปรับปรุงประสบการณ์อย่างไร",
    "cookiesWhatAreHeading": "คุกกี้คืออะไร",
    "cookiesWhatAre":
      "คุกกี้คือไฟล์ข้อความขนาดเล็กที่จัดเก็บไว้ในเบราว์เซอร์ของคุณเมื่อคุณเยี่ยมชมเว็บไซต์ ช่วยในเรื่องฟังก์ชันการทำงาน การกำหนดค่า และสถิติการใช้งาน",
    "cookiesHowWeUseHeading": "วิธีที่เราใช้คุกกี้",
    "cookiesHowWeUse":
      "เราอาจใช้คุกกี้เพื่อการทำงานที่จำเป็นของเว็บไซต์ (ความปลอดภัย ประสิทธิภาพ และการตั้งค่าสำคัญ) จดจำค่ากำหนด เช่น ภาษา ธีม และตัวกรอง วิเคราะห์การใช้งานเพื่อปรับปรุงเนื้อหา และหากมีโฆษณา พันธมิตรอาจใช้คุกกี้เพื่อวัดผลและปรับโฆษณาให้เหมาะกับผู้ใช้",
    "cookiesThirdPartyHeading": "คุกกี้ของบุคคลที่สาม",
    "cookiesThirdParty":
      "เราอาจใช้บริการของบุคคลที่สาม (เช่น โฮสติ้ง การวิเคราะห์ CDN เครือข่ายโฆษณา) ผู้ให้บริการเหล่านี้อาจตั้งค่าคุกกี้ของตนเอง คุณสามารถตรวจสอบหรือจัดการได้ผ่านทางแบนเนอร์ยินยอมของเว็บไซต์",
    "cookiesConsentHeading": "ความยินยอมและการควบคุม",
    "cookiesConsent":
      "คุณสามารถควบคุมคุกกี้ผ่านแบนเนอร์ยินยอมที่แสดงเมื่อคุณเข้าชมครั้งแรก การตั้งค่าเบราว์เซอร์ (บล็อกหรือลบคุกกี้) หรือโหมดส่วนตัว/ไม่ระบุตัวตน การบล็อกคุกกี้ที่จำเป็นอาจทำให้คุณลักษณะของไซต์เสียหายได้",
    "cookiesContactBefore": "หากมีคำถามเกี่ยวกับคุกกี้ โปรดไปที่",
    "sitemapTitle": "แผนผังเว็บไซต์",
    "sitemapIntro": "ส่วนหลักและหน้าของ heartopia.guide",
    "sitemapXmlLabel": "sitemap.xml",
    "sitemapXmlNote": "สำหรับเครื่องมือค้นหา",
    "sitemapResourcesHeading": "ทรัพยากร",
    "sitemapSupportHeading": "สนับสนุน",
    "sitemapLegalHeading": "ข้อมูลทางกฎหมาย",
  },
  "consent": {
    "bannerLabel": "ความยินยอมของคุกกี้",
    "message": "เราใช้คุกกี้เพื่อคุณลักษณะที่จำเป็นของไซต์ และหากคุณอนุญาต เพื่อวัดการใช้งานและแสดงโฆษณา",
    "learnMore": "เรียนรู้เพิ่มเติมเกี่ยวกับคุกกี้",
    "acceptCta": "ยอมรับทั้งหมด",
    "rejectCta": "ปฏิเสธสิ่งที่ไม่จำเป็น",
  },
};

export default th;
